<script setup lang="ts">

interface ContactFormPrivacyCTAProps {
  href: string;
  linkMessage: string
}

defineProps<ContactFormPrivacyCTAProps>();
</script>

<template>
  <div class="privacy-cta">
    <a
      class="button"
      :href="href"
      target="_blank"
      rel="noopener noreferrer"
      data-pw-form="privacy-cta"
    >
      {{ linkMessage }}
    </a>
      </div>
</template>

<style lang="scss" scoped>
@use "../../site/mixins";

.privacy-cta {
  @include mixins.button-base;

    a {
        @include mixins.button-primary; 
        width: auto;

        &.disabled,
        &[aria-disabled="true"] {
          background-color: #ccc;
          color: #888;
          cursor: not-allowed;
          pointer-events: none; 
        }
    }
  }

</style>